export class Store {
  public static readonly data: Record<string, any> = {};

  public static set<T = any>(key: string, value: T) {
    this.data[key] = value;
  }

  public static get<T = any>(key: string): T {
    return this.data[key];
  }
}
